import { ButtonProps } from "@/types/ui-kit/buttons";
import React from "react";

export const PrimaryTinyButton: React.FC<ButtonProps> = ({ onClick, title, fullWidth }) => {
  return (
    <button
      className={`rounded-full bg-black px-3 py-1 font-sans text-xs font-normal text-white dark:bg-white dark:text-dark ${
        fullWidth ? "w-full" : ""
      }`}
      onClick={onClick}
      type="submit"
    >
      {title}
    </button>
  );
};
